/* global LOGIN_CONFIG, zooplusApp */
import { logException } from '../services/sentryService';

let configData = {};
export const SSO_TIMEOUT = 10000;
export const URL_REGEX =
  /^(((https?):\/\/)(%{2}|[-()_.!~*';/?:@&=+$, A-Za-z0-9])+)([).!';/?:, ][[:blank:]])?$/i;
export const PATH_REGEX = /^\/(.)*$/i;

export const setSSOConfig = (initData = {}) => {
  // Id of the login form
  configData.FORM_ID = initData.formId || 'loginForm';
  // Id of the iframe
  configData.IFRAME_ID = initData.iframeId || 'sso-iframe';
  // Configuration object to initialize keycloack (using property ssoLoginUrl)
  configData.LOGIN_CONFIG = initData.loginConfig || LOGIN_CONFIG;
};

export const getConfigData = () => configData;

export const loadSSOIframe = () => {
  const loginFrame = document.getElementById(configData.IFRAME_ID);
  loginFrame.onload = function () {
    loginFrame.contentWindow.postMessage('ACK', '*');
  };
  loginFrame.src = configData.LOGIN_CONFIG.ssoLoginUrl;
};

// We need inform mobile apps in cases customers are stuck on login page
// * when sso iFrame didn't manage to initialize shop-checkout session from an existing SSO session
// * when sso iFrame couldn't manage to communicate with Keycloak server
const handleUserMessage = (elementSelector) => {
  if (
    typeof zooplusApp != 'undefined' &&
    typeof zooplusApp.loginState === 'function'
  ) {
    const errorMessageElement = document.querySelector(elementSelector);
    if (errorMessageElement) {
      errorMessageElement.classList.remove('hide');
    }
    zooplusApp.loginState(false);
  }
};

const postMessageEventListener = (event) => {
  switch (event.data.type) {
    case 'CHALLENGE_PAGE':
      if (window.location.href.includes('logout')) {
        location.href = '/checkout/logout-sso';
      }

      handleUserMessage('.js-keycloakChallengePageErrorMessage');
      break;
    case 'LOGIN_SUCCESS':
      if (URL_REGEX.test(event.data.path) || PATH_REGEX.test(event.data.path)) {
        location.href = event.data.path;
      } else {
        location.href = '/checkout/preview';
      }
      break;
    case 'ALREADY_AUTHENTICATED':
      location.reload();
      break;
    default:
      if (event.origin.includes('login') && event.data.type) {
        logException(
          'Checkout. Unknown Keycloak event type',
          { area: 'sso' },
          { event_data: event.data }
        );

        handleUserMessage('.js-keycloakErrorMessage');
      }
      break;
  }
};

/* This logic is used for the apps */
export const initSSO = (data = {}) => {
  setSSOConfig(data);
  loadSSOIframe();
  window.addEventListener('message', postMessageEventListener, false);
};
